<template>
  <ul :class="$blockClass(blockClass, 'highlights-grid')">
    <li
      v-for="(highlight, index) of highlights"
      :key="index"
      :class="$blockClass(blockClass, 'highlight')"
    >
      <a
        v-if="highlight.link"
        :class="$blockClass(blockClass, 'highlight-inner')"
        :href="highlight.link"
        :tabindex="isTabbable ? 0 : -1"
      >

        <responsive-image
          :image="highlight.image"
          min-max="200-500"
          :ratio="false"
        />

        <span
          v-if="highlight.title"
          class="text-body-m-regular"
          :class="$blockClass(blockClass, 'highlight-title')"
          v-text="highlight.title"
        />
      </a>

      <div
        v-else
        :class="$blockClass(blockClass, 'highlight-inner')"
      >
        <responsive-image
          :image="highlight.image"
          min-max="200-500"
          :ratio="false"
        />

        <span
          v-if="highlight.title"
          class="text-body-m-regular"
          :class="$blockClass(blockClass, 'highlight-title')"
          v-text="highlight.title"
        />
      </div>
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Nav highlights (nav-highlights)
 * -----------------------------------------------------------------------------
 * Featured images and links for nav panels and drawers.
 * @param {Array} highlights - Highlights merchandised through block settings.
 * @param {Boolean} isTabbable - Based on menu active state.
 * @param {String} [blockClass] - Block level class to apply to all elements.
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'NavHighlights',

  components: {
    ResponsiveImage,
  },

  props: {
    highlights: {
      type: Array,
      default: () => [],
    },
    isTabbable: {
      type: Boolean,
      default: false,
    },
    blockClass: {
      type: String,
      default: '',
    },
  },
}
</script>
